import { render, staticRenderFns } from "./intoVideo.vue?vue&type=template&id=2afcd82d&"
import script from "./intoVideo.vue?vue&type=script&lang=js&"
export * from "./intoVideo.vue?vue&type=script&lang=js&"
import style0 from "./intoVideo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCardTitle,VIcon})
